/**
 * @file Environment.ts
 * @description Utilities for checking the environment
 *
 * @module Environment
 */
/**
 * Get the user ID from the cookie
 *
 * @example
 *
 * import { Environment } from '@catawiki/runtime-toolkit';
 *
 * // Check if the code is running on the client side
 * expect(Environment.isClientSide()).toBe(true);
 *
 * @returns True if the code is running on the client side
 *
 */
export const isClientSide = () => {
    if (typeof globalThis.window === 'undefined') {
        return false;
    }
    return true;
};
